/**
* @Description 文件功能说明：修改密码弹窗
* @Author cc
* @Time 2021/04/01
**/

/* HTML */
<template>
    <el-dialog :title="dialogForm.title"
               :visible.sync="dialogForm.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form :model="dialogRowForm" :rules="rules" ref="dialogRowForm" label-width="120px">
            <el-form-item label="系统Logo：" prop="systemLogo" style="display: none;">
                <el-input v-model="dialogRowForm.systemLogo" type="text" autocomplete="false" clearable/>
            </el-form-item>
            <el-form-item label="系统名称：" prop="systemName">
                <el-input v-model="dialogRowForm.systemName" type="text" autocomplete="false" clearable/>
            </el-form-item>
            <el-form-item label-width="0px" class="btn-form-item-c" style="padding-top: 10px;text-align: center;">
				<el-button  type="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

/* JS */
<script>
    import ApiAccount from '@/request/api-account'
    import {checkEmpty,validFormat,checkFormat} from '@/global/global-valid'

    export default {
        /**
         * @Des 组件名
         * @Auth Zhangbin
         * @Date 16:37 2021/4/30
         */
        name: 'PasswordDialog',
        /**
         * @Des 数据定义
         * @Auth Zhangbin
         * @Date 16:37 2021/4/30
         */
        data() {
            return{
                /**
                 * @Des 弹窗表单
                 * @Auth Zhangbin
                 * @Date 16:37 2021/4/30
                 */
                dialogForm: {
                    isEdit: true,
                    title: "修改系统信息",
                    dialogFormVisible: false,
                    submitButton: '提交'
                },
                /**
                 * @Des 弹窗行值
                 * @Auth Zhangbin
                 * @Date 16:38 2021/4/30
                 */
                dialogRowForm: {
                    systemLogo: '',
                    systemName: "",
                },
                /**
                 * @Des 弹窗规则
                 * @Auth Zhangbin
                 * @Date 16:38 2021/4/30
                 */
                rules: {
                    systemName: [
                        { required: true, message: '请输入系统名称', trigger: 'blur' },
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkFormat(value, validFormat.password) && false) {
	                            	new callback(new Error("6-18位，可包含数字、字母、英文符号"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                }
            }
        },
        /**
         * @Des 方法定义
         * @Auth Zhangbin
         * @Date 16:38 2021/4/30
         */
        methods:{
            /**
             * @Des 弹窗打开
             * @Auth Zhangbin
             * @Date 16:38 2021/4/30
             */
            openDialog(isEdit, data, index){
                this.dialogForm.isEdit = isEdit;
                this.dialogForm.dialogFormVisible = true;
                if(isEdit && data){
                    this.dialogRowForm.systemLog = data.systemLog;
                    this.dialogRowForm.systemName = data.systemName;
                }
            },
            /**
             * @Des 弹窗关闭
             * @Auth Zhangbin
             * @Date 16:38 2021/4/30
             */
            handleDialogClose(){
                this.reset()
            },
            /**
             * @Des 重置方法
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            reset(){
                this.cleanData(this.dialogRowForm);
                this.cleanValidate('dialogRowForm');
            },
            /**
             * @Des 提交方法
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            submitForm(){
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;
                    this.$request.postJsonRequest(ApiAccount.saveSystemNameApi, {
                        systemLogo: this.dialogRowForm.systemLogo,
                        systemName: this.dialogRowForm.systemName,
                    }).then(result => {
                        // console.log(result); return false;
                        if(result.code == 0){
                        	  this.dialogForm.dialogFormVisible = false;
                            this.$emit("updateSystemParam", {
                              logo: this.dialogRowForm.systemLogo,
                              name: this.dialogRowForm.systemName
                            });
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('系统名称修改密码异常', ApiAccount.saveSystemNameApi, error);
                    })
                })
            },
            /**
             * @Des 清除验证
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清理数据
             * @Auth Zhangbin
             * @Date 16:39 2021/4/30
             */
            cleanData(form){
                this.$nextTick(function () {
                    form.accountId = '';
                    form.account = '';
                    form.oldPasword = '';
                    form.newPassword = '';
                    form.reNewPassword = '';
                })
            },
            /**
             * @Des 移除cookie
             * @Auth Zhangbin
             * @Date 16:57 2021/4/30
             */
			removeCookies() {
				this.$cookies.remove("username");
                this.$cookies.remove("usernameSecret");
				this.$cookies.remove("passwordSecret");
			},
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Account/SystemDialog.vue